/**
 * Stream Monitor Constants
 * Shared constants used across StreamMonitor components
 */

// Period options for dropdown
export const PERIOD_OPTIONS = [
  { value: 'today', label: 'Σήμερα (Preview)', hint: '⏳ Ημιτελές', excludeFromStats: true },
  { value: 'yesterday', label: 'Χθες', hint: '✅ Πλήρες' },
  { value: 'current_week', label: 'Τρέχουσα Εβδομάδα', hint: '⏳ Preview', excludeFromStats: true },
  { value: 'week', label: 'Προηγ. Εβδομάδα', hint: 'Δευ-Κυρ' },
  { value: 'weeks_2', label: '2 Εβδομάδες', hint: 'Ημερολογιακές' },
  { value: 'weeks_3', label: '3 Εβδομάδες', hint: 'Ημερολογιακές' },
  { value: 'prev_month', label: 'Προηγ. Μήνας', hint: 'Ημερολογιακός' },
  { value: 'months_3', label: '3 Μήνες', hint: 'Τελευταίο τρίμηνο' },
  { value: 'months_6', label: '6 Μήνες', hint: 'Τελευταίο εξάμηνο' },
  { value: 'months_12', label: '12 Μήνες', hint: 'Τελευταίος χρόνος' },
  { value: 'custom', label: '📅 Επιλογή ημερομηνιών', hint: 'Date range' }
];

// Greek day names (full and short)
export const DAY_NAMES = ['Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ', 'Κυρ'];
export const DAY_NAMES_FULL = ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'];

// Greek month names
export const MONTH_NAMES = [
  'Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος',
  'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'
];

// Default schedule
export const DEFAULT_SCHEDULE = {
  schedule_enabled: true,
  schedule_days: [0, 1, 2, 3, 4, 5, 6],
  schedule_start_time: '06:00',
  schedule_end_time: '20:00',
  manual_override: false
};

// Score/Ranking color mapping
export const SCORE_COLORS = {
  'POWER': 'text-red-500 font-bold',
  'SECONDARY': 'text-orange-500 font-bold', 
  'CURRENTS': 'text-green-500',
  'RECURRENTS': 'text-indigo-500',
  'GOLD': 'text-amber-500',
  'SLOW DOWN': 'text-yellow-500',
  'CUT': 'text-gray-400',
  'NEW': 'text-blue-500 font-bold',
  'ADDED': 'text-cyan-500 font-bold',
  'PENDING': 'text-purple-400 italic',
  // Legacy
  'FULL': 'text-green-400',
  '3/4': 'text-blue-400',
  '1/2': 'text-yellow-400',
  '1/4': 'text-orange-400',
  'SKIP': 'text-red-400'
};

// Ranking category background styles
export const RANKING_CATEGORY_STYLES = {
  'POWER': 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  'SECONDARY': 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
  'CURRENTS': 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  'RECURRENTS': 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400',
  'GOLD': 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  'SLOW DOWN': 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
  'CUT': 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  'NEW': 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  'ADDED': 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400',
  'PENDING': 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400'
};

// Ranking category labels with emojis
// 2026-05-15: 'NEW' / 'ADDED' labels neutralised to a dash because duplicate
// canonicals were producing false-positive NEW indicators for songs already
// in rotation for months. Underlying classification (used for sorting and
// scoring) is preserved — only the visible label is hidden.
export const RANKING_LABELS = {
  'POWER': '🔥 POW',
  'SECONDARY': '⭐ SEC',
  'CURRENTS': '✅ CUR',
  'RECURRENTS': '🔄 REC',
  'GOLD': '📚 GLD',
  'SLOW DOWN': '⚠️ SLD',
  'CUT': '❌ CUT',
  'NEW': '—',
  'ADDED': '—',
  'PENDING': '⏳ PND',
  // Legacy
  'FULL': '🟢',
  '3/4': '🔵',
  '1/2': '🟡',
  '1/4': '🟠',
  'SKIP': '🔴'
};
